import React from 'react';
import { XIcon, PlusCircleIcon } from 'lucide-react';
interface PlotPopupProps {
  plot: {
    dagNo: string;
    khatians: Array<{
      id: string;
      khatianNo: string;
      ownerName: string;
      area: string;
    }>;
  };
  onClose: () => void;
  addToCart: (khatian: any) => void;
}
export const PlotPopup = ({
  plot,
  onClose,
  addToCart
}: PlotPopupProps) => {
  return <div className="w-64" data-id="element-228">
      <div className="flex justify-between items-center mb-2" data-id="element-229">
        <h3 className="text-lg font-semibold" data-id="element-230">ডাগ/প্লট বিবরণ</h3>
        <button className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full" onClick={onClose} data-id="element-231">
          <XIcon className="h-4 w-4" data-id="element-232" />
        </button>
      </div>
      <div className="border-b pb-2 mb-2" data-id="element-233">
        <span className="font-medium" data-id="element-234">ডাগ নং:</span>
        <span className="ml-2" data-id="element-235">{plot.dagNo}</span>
      </div>
      <div className="space-y-3" data-id="element-236">
        <h4 className="font-medium" data-id="element-237">খতিয়ান তালিকা:</h4>
        {plot.khatians.map(khatian => <div key={khatian.id} className="border rounded-md p-2 bg-gray-50" data-id="element-238">
            <div className="flex justify-between items-start" data-id="element-239">
              <div data-id="element-240">
                <div data-id="element-241">
                  <span className="font-medium" data-id="element-242">খতিয়ান নং:</span>
                  <span className="ml-1" data-id="element-243">{khatian.khatianNo}</span>
                </div>
                <div className="text-sm text-gray-600 mt-1" data-id="element-244">
                  <div data-id="element-245">
                    <span data-id="element-246">মালিকের নাম:</span>
                    <span className="ml-1" data-id="element-247">{khatian.ownerName}</span>
                  </div>
                  <div data-id="element-248">
                    <span data-id="element-249">এলাকা (শতক/একর):</span>
                    <span className="ml-1" data-id="element-250">{khatian.area}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-2" data-id="element-251">
              <button className="w-full flex items-center justify-center py-1 px-2 bg-blue-100 text-blue-800 hover:bg-blue-200 rounded text-sm" onClick={() => {
            addToCart(khatian);
          }} data-id="element-252">
                <PlusCircleIcon className="h-4 w-4 mr-1" data-id="element-253" />
                <span data-id="element-254">কার্টে যোগ করুন</span>
              </button>
            </div>
          </div>)}
      </div>
    </div>;
};